import React, {
  useCallback,
  useState,
  useRef,
  useEffect,
  ChangeEvent,
} from 'react';

import Grid from '@material-ui/core/Grid';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import api from '../../../../../../../services/api';
import { useRegisterAdded } from '../../../../../../../hooks/registerAdded';
import { useEditProduto } from '../../../../../../../hooks/editProduto';
import { useToast } from '../../../../../../../hooks/toast';
import { useAuth } from '../../../../../../../hooks/auth';

import Complemento from '../../NewProdutoSimples/tabs/Complemento';
import AcordeaoComplementos from '../Acordeao';

import {
  TabWrapper,
  DrawerTabTitle,
  HasComplementoWrapper,
  ButtonAction,
  ComplementosStoredWrapper,
} from '../../../drawer_styles';
import { SubmitButtonWrapper } from '../../../../styles';

interface ComplementoType {
  id: number;
  empresa_id: number;
  descricao: string;
  qtd_min: number;
  qtd_max: number;
  complemento_obrigatorio: boolean;
  tipo: number;
  imagem?: File;
  ordem: number;
  ativo: boolean;
}

interface ComplementosProps {
  grupo_produto_id: number;
}

const Complementos: React.FC<ComplementosProps> = ({ grupo_produto_id }) => {
  const [complementos, setComplementos] = useState<ComplementoType[]>([]);
  const [hasComplemento, setHasComplemento] = useState('no');
  const [btnEnabled, setBtnEnabled] = useState(false);

  const formRef = useRef<FormHandles>(null);
  const {
    hasComplementoUpdated,
    handleSetHasProductUpdated,
    handleSetDrawerWasClosed,
  } = useRegisterAdded();
  const {
    produto,
    sempreDisponivel,
    turnos,
    disponibilidade,
  } = useEditProduto();

  const { user } = useAuth();
  const { addToast } = useToast();

  useEffect(() => {
    async function loadComplementos() {
      const response = await api.get(`/complemento/${grupo_produto_id}`);

      setComplementos([...response.data]);

      if (response.data.length > 0) {
        setHasComplemento('yes');
        setBtnEnabled(true);
      }
    }

    if (hasComplementoUpdated) {
      loadComplementos();
    }

    loadComplementos();
  }, [hasComplementoUpdated]);

  const handleRadioBtnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setHasComplemento(e.target.value);

      if (e.target.value === 'no') setBtnEnabled(false);
      else if (e.target.value === 'yes') setBtnEnabled(true);
    },
    [],
  );

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        const productWillBeStored = {
          unidade_medida_id: produto.unidade_medida_id,
          descricao: produto.descricao,
          codigo: produto.codigo ? produto.codigo : null,
          gtin: produto.gtin ? produto.gtin : null,
          observacao: produto.observacao,
          empresa_id: user.empresa_id,
          grupo_id: produto.grupo_id,
        };

        await api.put(`/produto/${produto.id}`, { ...productWillBeStored });
        await api.put(`/produto/preco/${produto.id}`, {
          valor: produto.preco,
          grupo_id: productWillBeStored.grupo_id,
        });
        await api.put(`/produto/disponibilidade/${produto.id}`, {
          role: { dias: disponibilidade.dias, turnos },
        });
        await api.put(`/estoque/${produto.id}`, {
          estoque_minimo: produto.estoque_minimo,
          estoque_atual: produto.estoque_atual,
        });

        addToast({
          type: 'success',
          title: 'Produto Atualizado',
        });

        handleSetHasProductUpdated(true);
        handleSetDrawerWasClosed(true);
      } catch (err) {
        const { message } = err.response.data;

        addToast({
          type: 'error',
          title: message,
        });
      }
    },
    [
      produto,
      user,
      addToast,
      handleSetHasProductUpdated,
      handleSetDrawerWasClosed,
    ],
  );

  return (
    <TabWrapper>
      <DrawerTabTitle>
        <h1>Complementos</h1>
        <span>Aqui você pode editar os complementos do seu produto :&#41;</span>
      </DrawerTabTitle>

      <Form ref={formRef} onSubmit={() => {}}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <HasComplementoWrapper>
              <div>
                <span>Selecione uma opção:</span>

                <form>
                  <label htmlFor="no_have">
                    <input
                      checked={hasComplemento === 'no'}
                      type="radio"
                      id="no_have"
                      name="has_complemento"
                      value="no"
                      onChange={handleRadioBtnChange}
                    />
                    Não, este produto não tem complemento
                  </label>

                  <label htmlFor="have">
                    <input
                      checked={hasComplemento === 'yes'}
                      type="radio"
                      id="have"
                      name="has_complemento"
                      value="yes"
                      onChange={handleRadioBtnChange}
                    />
                    Sim, este produto tem complemento
                  </label>
                </form>
              </div>
            </HasComplementoWrapper>
          </Grid>

          <Grid item xs={12}>
            <Complemento
              isEnabled={btnEnabled}
              grupo_produto_id={grupo_produto_id}
            />
          </Grid>

          {complementos.length > 0 && (
            <Grid item xs={12}>
              <ComplementosStoredWrapper>
                <h2>Grupos de complementos que compõem esse produto</h2>
              </ComplementosStoredWrapper>

              <AcordeaoComplementos complementos={complementos} />
            </Grid>
          )}

          <Grid item xs={12}>
            <SubmitButtonWrapper>
              <ButtonAction
                type="button"
                className="cancel"
                onClick={() => handleSetDrawerWasClosed(true)}
              >
                Cancelar
              </ButtonAction>

              <ButtonAction
                type="submit"
                className="submit"
                onClick={handleSubmit}
              >
                Salvar
              </ButtonAction>
            </SubmitButtonWrapper>
          </Grid>
        </Grid>
      </Form>
    </TabWrapper>
  );
};

export default Complementos;
